import React from 'react';
import { Box } from '@mui/material';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import WarehouseListContainer from '../../containers/inventorymng/WarehouseListContainer';

const WarehouseListPage = () => {
    return (
        <Box>
            <BreadcrumbsContainer title="제품관리/창고 관리/창고 목록" icon="warehouse" />
            <WarehouseListContainer />
        </Box>
    );
};

export default WarehouseListPage;
